
























































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { GatewayTypes, PaymentActionTypes } from "@/data/enums";
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { IPaymentDetail } from "@/models/paymentDetails";
import { ConfirmModalModes } from "@/data/enums";
import { IGatewayProvider } from "@/models/gateways";
import _ from "@/boot/lodash";

@Component
export default class PaymentMethodVessel extends Mixins(
  RequestPromises,
  Context
) {
  @Prop({
    required: false,
    default: PaymentActionTypes.LIST,
    validator: value => {
      return _.values(PaymentActionTypes).includes(value) as boolean;
    }
  })
  public action!: string;
  @Prop({ required: true })
  public method!: IPaymentDetail;
  @Prop({ default: false })
  public isSelected!: boolean;
  public dataModule: string = DataModules.CLIENTS_PAYMENT_DETAILS;

  public async makeMethodDefault() {
    if (!this.canUpdate) {
      return;
    }
    await this.$store.dispatch(`data/${this.dataModule}/update`, {
      id: this.method.client_id,
      payment_details_id: this.method.id,
      data: {
        default: true
      }
    });
    this.$emit("payment-method-updated");
  }

  public editPaymentMethod() {
    if (!this.canUpdate) {
      return;
    }
    this.$store.dispatch(`data/${this.dataModule}/openEditModal`, {
      props: {
        method: this.method
      },
      events: {
        "payment-method-updated": () => this.$emit("payment-method-updated")
      }
    });
  }

  public get canDelete() {
    return this.$userCan(`delete_client_payment_detail`);
  }

  public get canUpdate() {
    return this.$userCan(`update_client_payment_detail`);
  }

  public isCardGateway(gateway: IGatewayProvider) {
    return gateway.type === GatewayTypes.CARD;
  }

  public async deletePaymentMethod() {
    if (!this.canDelete) return;
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          mode: ConfirmModalModes.BUTTON,
          autoClose: false,
          action: this.$t("_action.delete_object", {
            object: (this.$t("_.payment_method") as string).toLowerCase()
          }),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.payment_method") as string).toLowerCase()
          })
        },
        canCancel: ["escape", "outside", "button"],
        events: {
          confirmed: async () => {
            try {
              await this.$store.dispatch(`data/${this.dataModule}/remove`, {
                id: this.method.client_id,
                payment_details_id: this.method.id
              });
              this.$emit("payment-method-updated");
              this.$buefy.toast.open({
                message: this.$t("_.object_deleted", {
                  object: this.$t("_.payment_method")
                }) as string
              });
            } catch (error) {
              this.$store.dispatch("api/handleValidationError", {
                error,
                vm: this
              });
            }
            confirm.close();
          }
        }
      }
    });
  }
}
